import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {Typography, Box, Divider} from '@mui/material'
import {BulkEditPropertyProps} from './BulkEditDialogProperties'
import {BulkEditProperty} from './BulkEditProperty'
import {makeStyles} from '@oc/styles'

const useStyles = makeStyles({
    groupTitle: {
        marginTop: '5px',
        marginBottom: '10px'
    }
})

interface BulkEditPropertyGroupProps {
    groupProperties: BulkEditPropertyProps[]
    groupName: string
    groupIndex: number
    shouldBlockCancelConfirmCallback: React.Dispatch<React.SetStateAction<boolean>>
}

function _BulkEditPropertyGroup(props: BulkEditPropertyGroupProps) {
    const {groupProperties, groupName, groupIndex, shouldBlockCancelConfirmCallback} = props
    const {classes} = useStyles()

    return (
        <Box>
            <Divider key={`group-divider-${groupName}`} />
            <Typography className={classes.groupTitle}>{groupName}</Typography>

            {groupProperties
                .filter(bulkProp => bulkProp.isVisible)
                .map((bulkProp, propIdx) => (
                    <BulkEditProperty
                        key={`group-prop-${groupIndex}-${propIdx}`}
                        property={bulkProp}
                        propertyIndex={propIdx}
                        groupIndex={groupIndex}
                        shouldBlockCancelConfirmCallback={shouldBlockCancelConfirmCallback}
                    />
                ))}
        </Box>
    )
}

export const BulkEditPropertyGroup = observer(_BulkEditPropertyGroup)
